import { ref } from 'vue'
import { useUcConsentManager } from '#imports'

export const usePopupConsent = () => {
    const { onUcIsInitialized, getUcServiceStatus, onUcConsentChange } = useUcConsentManager()
    const hasConsent = ref(false)

    const initConsentTracking = () => {
        onUcIsInitialized(() => {
            const ucServiceName = 'Google Tag Manager'
            hasConsent.value = getUcServiceStatus(ucServiceName)

            onUcConsentChange((e: CustomEvent) => {
                if (e.detail && e.detail.event === 'consent_status') {
                    hasConsent.value = e.detail[ucServiceName] === true
                }
            })
        })
    }

    return { hasConsent, initConsentTracking }
}
